import { SessionTimeoutHelper } from "@sssuite-component-ui/session-timeout";
import { useAppDispatch, useAppSelector } from "../common/hooks/redux-hooks";
import { AppState } from "../store";
import { userSignedOut } from "../store/services/auth-service";
import { signoutRedirect } from "./userService";


export interface WithLogoutProps {
    onLogout: () => void;
}

export const WithLogout = (Component: React.ComponentType) => {
    return function Wrapper(props: any) {

        const user = useAppSelector((state: AppState) => state.authReducer?.authentication.user);
        const device_id = user?.profile?.device_id;
        const dispatch = useAppDispatch();
        return (
            <Component
                {...props}
                onLogout={() => {
                    SessionTimeoutHelper.logoutHelper(device_id, signoutRedirect);
                    dispatch(userSignedOut());
                }}
            />
        );
    };
};
